module.exports = __webpack_public_path__ + "static/media/029-man-8.3f65c620.svg";